import DataList from "components/datatable/DataList";
import React, { useMemo } from "react";
import useAxios from "hooks/useAxios";
import useAxiosFunction from "hooks/useAxiosFunction";
import { useAuth } from "context/AuthProvider";
import { RuleRequired } from "utils/MyUtils";
import {
  boolText,
  hasPermission,
  parseGroupIDs,
  showEmpty,
} from "./SystemPageUtils";

export default function PermissionManagementPage() {
  const { user } = useAuth();
  const [groupsResp] = useAxios({
    method: "GET",
    url: "/system/groups",
    params: { perpage: 500 },
    auth: true,
  });
  const [, , , axiosFetch] = useAxiosFunction();
  const canManage = hasPermission(user, "system.permission.manage");

  const groups = Array.isArray(groupsResp?.data) ? groupsResp.data : [];
  const columns = canManage
    ? [
        "no",
        "permission_code",
        "permission_name",
        "module",
        "assigned_groups",
        "is_active",
        "action",
      ]
    : [
        "no",
        "permission_code",
        "permission_name",
        "module",
        "assigned_groups",
        "is_active",
      ];

  const coltype = useMemo(
    () => ({
      id_permission: { type: "hidden", name: "id_permission" },
      permission_code: {
        label: "Permission Code",
        type: "text",
        name: "permission_code",
        colsize: 4,
        validation: RuleRequired,
        width: 180,
      },
      permission_name: {
        label: "Permission Name",
        type: "text",
        name: "permission_name",
        colsize: 5,
        validation: RuleRequired,
        width: 220,
      },
      module: {
        label: "Module",
        type: "text",
        name: "module",
        colsize: 3,
        renderFunc: (val) => showEmpty(val),
        width: 140,
      },
      description: {
        label: "Description",
        type: "textarea",
        name: "description",
        colsize: 12,
        renderFunc: (val) => showEmpty(val),
      },
      group_ids: {
        label: "Assign ke Group",
        type: "listcheckbox",
        name: "group_ids",
        colsize: 12,
        checklist: groups,
        valueId: "id_group",
        labelId: "groupname",
        itemcolsize: 4,
      },
      assigned_groups: {
        label: "Group",
        renderFunc: (val) => showEmpty(val),
      },
      is_active: {
        label: "Status",
        type: "checkbox",
        name: "is_active",
        colsize: 2,
        renderFunc: (val) => boolText(val),
        width: 100,
        align: "center",
      },
      action: { label: "Aksi", align: "center", width: 100 },
    }),
    [groups],
  );

  const savePermission = async (form, defaultValue = {}) => {
    const id = form?.id_permission || defaultValue?.id_permission || "";
    const method = id ? "PUT" : "POST";
    const url = id ? `/system/permissions/${id}` : "/system/permissions";

    return axiosFetch({
      method,
      url,
      auth: true,
      data: {
        permission_code: form.permission_code,
        permission_name: form.permission_name,
        module: form.module || "",
        description: form.description || "",
        is_active: Boolean(form.is_active),
        group_ids: parseGroupIDs(form.group_ids),
      },
    });
  };

  return (
    <>
      {!canManage ? (
        <div className="alert alert-info">
          Mode baca saja. User aktif tidak memiliki permission
          `system.permission.manage`.
        </div>
      ) : null}
      <DataList
        title="Daftar Permission"
        coltype={coltype}
        dlist={{
          url: "/system/admin/permissions",
          columns,
          filter: [{ dtype: "q", name: "q", colsize: 4 }],
          sort_by: [
            "permission_code",
            "permission_name",
            "module",
            "assigned_groups",
          ],
        }}
        addconfig={
          canManage
            ? {
                columns: [
                  "permission_code",
                  "permission_name",
                  "module",
                  "is_active",
                  "description",
                  "group_ids",
                ],
                title: "Penambahan Permission",
                label_tool: "Tambah Permission",
                saveHandle: savePermission,
              }
            : null
        }
        editconfig={
          canManage
            ? {
                columns: [
                  "id_permission",
                  "permission_code",
                  "permission_name",
                  "module",
                  "is_active",
                  "description",
                  "group_ids",
                ],
                title: "Perubahan Permission",
                url: "/system/permissions",
                urlitem: "/system/permissions",
                cellid: "id_permission",
                saveHandle: savePermission,
                normalizeItem: (item) => ({
                  ...item,
                  group_ids: parseGroupIDs(
                    item?.group_ids || item?.assigned_group_ids,
                  ),
                }),
              }
            : null
        }
        delconfig={
          canManage
            ? {
                url: "/system/permissions",
                cellid: "id_permission",
                cellname: "permission_code",
              }
            : null
        }
        activateconfig={
          canManage
            ? {
                url: "/system/permissions",
                cellid: "id_permission",
                cellname: "permission_code",
                cellactivate: "is_active",
                labelactivate: "Aktifkan",
                labelinactivate: "Non-aktifkan",
                cfmactivate: "mengaktifkan",
                cfminactivate: "menonaktifkan",
                infoactivate: "diaktifkan",
                infoinactivate: "dinonaktifkan",
              }
            : null
        }
      />
    </>
  );
}
